<template>
  <app-modal class="warning-alert-modal" @close="close">
    <app-modal-default styling="error" @close="close">
      <template v-slot:header>
        {{$ml.get('Tank')}} {{ name }}
      </template>
      <div class="content">
        <div class="item" v-for="item in alerts">
          {{ $ml.get(item.Message) }}
        </div>
      </div>
    </app-modal-default>
  </app-modal>
</template>

<script>
export default {
  props: {
    alerts: {},
    name: {},
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>

.warning-alert-modal {
  .app-modal-default {
    max-width: 400px;
  }
  .content {
    .item {
      line-height: 1.5;
      padding: 5px 10px;
      border-top: 1px solid #E4E5E6;

      &:first-child {
        border-top: 0;
      }

    }
  }
}

</style>
